import { usePeriod } from "backend/model/usePeriod";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Query from "qpr-base/querybuilder/Query";

import { useQuery } from "react-query";
import useTopElements from "./useTopElements";

type IScorecardResult = {
  id: string;
  name: string;
};

const useScorecardTopElement = (symbol?: string) => {
  const ctx = useAppContext();

  const { data: topElems, isLoading: topElementsLoading } = useTopElements();

  const periods = usePeriod();

  // If top element of root scorecard is queried, check that user has at least view rights.
  // If not, return first top element that user has rights to
  let sc = undefined;
  if (symbol === "L0") {
    const rootSC = topElems?.find((el) => el.scorecardsymbol === "L0");
    if (rootSC?.accesslevel === "-1")
      symbol =
        topElems?.find((el) => el.accesslevel !== "-1")?.scorecardsymbol || "";
  }

  return useQuery<IScorecardResult | null>(
    `scorecard-${symbol}-${JSON.stringify(periods)}`,
    () => {
      if (symbol) {
        return Query(ctx.fullModelId)
          .BySymbol({ symbol })
          .topelement()
          .fetchValues<IScorecardResult>()
          .then((list) => list[0]);
      }
      return null;
    },
    { enabled: !!symbol, cacheTime: 5 * 100, staleTime: 4 * 100 }
  );
};

export default useScorecardTopElement;
